import { FC } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import Button from 'components/Button';
import SuccessIcon from 'components/icons/Success';
import AuthenticationLayout from 'components/AuthLayout';

const ButtonContainer = styled.div`
  button {
    margin-left: auto;
    margin-right: auto;
    margin-top: 2rem;
    padding: 0.7rem 1.1rem;
  }
`;

const PasswordChanged: FC = () => {
  return (
    <AuthenticationLayout
      title="Mot de passe modifié"
      subtitle="Votre mot de passe a bien été modifié. Vous pouvez désormais vous connecter."
      icon={<SuccessIcon />}
      src_image="/logo_institut_principal.png"
    >
      <ButtonContainer>
        <Link to="/authentication/login">
          <Button color="primary">Retourner à l'écran de connexion</Button>
        </Link>
      </ButtonContainer>
    </AuthenticationLayout>
  );
};

export default PasswordChanged;
